import { defaultConfig } from "../../../pages/reportFolio/pages/dashboard/pages/detail/constants"
import { Evidence } from "../../../service/reportFolio/response"
import { Constants } from "../../../utils/constants"
import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences"
import { transformPluralsEvidencesNumber } from "../../../utils/methods/evidences"
import { EvidenceToSendBody } from "../../../utils/types/generals"
import { FormatEvidenceData, formatEvidenceToUploadItems } from "../contants"
import { EvidenceGeneralConfig, EvidenceStateValue, EvidenDetail, UploadEvidencesDrawe } from "../types"

export const formatGeneralEvidenceConfig = ({ config = [], evidences }: { config?: EvidenceGeneralConfig[]; evidences?: Evidence[] }): FormatEvidenceData => {
    const firstFormat = config?.map((item) => ({
        evidence: item.evidenceTypeId,
        amount: item.paramsConfiguration?.amounts ?? 0,
        size: item.paramsConfiguration?.sizes,
        type: item?.paramsConfiguration?.types ?? Constants.acceptFile[item.evidenceTypeId.toString()],
        isRequired: !!item?.required,
        typeUser: item.type
    }))

    return formatEvidenceToUploadItems({ evidenceList: firstFormat?.length ? firstFormat : defaultConfig, evidences })
}

export const formatEvidencesToSendBody = ({ evidences }: { evidences: UploadEvidencesDrawe }) => {
    let body: EvidenceToSendBody = { evidences: [], comments: [] }
    Object.entries(evidences.value ?? {}).forEach(([key, value]) => {
        if (key == EvidencesTypeValueEnum.COMMENT?.toString()) {
            body = {
                ...body,
                comments: Object.values(value?.value ?? {})?.map((item) => item.url as string),
            }
        } else {
            let evidences: any = []
            Object.values(value?.value ?? {})?.forEach((item) => {
                evidences = [
                    ...evidences,
                    {
                        url: item.url,
                        originalname: item.name,
                        evidenceTypeId: key,
                    },
                ]
            })
            body = { ...body, evidences: [...body.evidences, ...evidences], }
        }
    })

    return body
}

export const formatEvidenceToUploadEvidence = ({ evidencesDetail, evidenceConfig }: { evidencesDetail: EvidenDetail; evidenceConfig?: EvidenceStateValue }): EvidenceStateValue | undefined => {
    let newEvidenceConfig: EvidenceStateValue = evidenceConfig ?? {}

    Object.entries(evidenceConfig ?? {})
        .forEach(([key, value]) => {
            let type = Number(key) as EvidencesTypeValueEnum
            const convert = transformPluralsEvidencesNumber[type]
            let evidenceValue = value?.value ?? {}
            const evidences = evidencesDetail?.[convert]

            evidences.filter(item => item.type == type)?.forEach((evidence, index) => {
                const name = evidence?.originalName || `${convert}-${index}`
                evidenceValue = {
                    ...evidenceValue,
                    [name]: {
                        name: name,
                        url: evidence.src || evidence?.name || '',
                        progress: false,
                        upload: false,
                    }
                }
            })
            newEvidenceConfig = {
                ...newEvidenceConfig,
                [key]: {
                    ...newEvidenceConfig[key],
                    value: evidenceValue
                }
            }
        })
    return newEvidenceConfig
}